var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDustbinCat12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.898,
    height: 30.996,
    viewBox: "0 0 24.898 30.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dustbin",
    transform: "translate(-6.984 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87735",
    "data-name": "Path 87735",
    d: "M43.736,16.944V26.29a.471.471,0,0,1-.47.47H42.139V38.876a.505.505,0,0,1-.47.47H39.133V29.765a.505.505,0,0,0-.47-.47.471.471,0,0,0-.47.47v9.581H35.658a.505.505,0,0,1-.47-.47V20.184l-3.522,3.1a1.451,1.451,0,0,1-1.972-.141,1.4,1.4,0,0,1,.094-1.972C31.431,19.386,35.282,15.3,36.5,15.3h5.589a1.664,1.664,0,0,1,1.644,1.644Z",
    transform: "translate(-11.853 -7.849)",
    fill: "#85899c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87736",
    "data-name": "Path 87736",
    d: "M42.3,3.694a3.194,3.194,0,1,1,3.194,3.194A3.2,3.2,0,0,1,42.3,3.694Z",
    transform: "translate(-18.73)",
    fill: "#85899c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87737",
    "data-name": "Path 87737",
    d: "M11.441,37.894a.533.533,0,0,1-.141-.376.475.475,0,0,1,.188-.329l1.879-1.409a.494.494,0,0,1,.611,0l1.832,1.6a.426.426,0,0,1,.141.329.533.533,0,0,1-.141.376L13.977,39.82a.454.454,0,0,1-.657,0Z",
    transform: "translate(-2.289 -18.655)",
    fill: "#85899c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87738",
    "data-name": "Path 87738",
    d: "M15.677,53.26l1.832,1.6a.507.507,0,0,1,.141.329.625.625,0,0,1-.141.376L15.677,57.3a.454.454,0,0,1-.657,0l-1.879-1.926A.533.533,0,0,1,13,55a.475.475,0,0,1,.188-.329l1.879-1.409a.44.44,0,0,1,.611,0Z",
    transform: "translate(-3.19 -27.916)",
    fill: "#85899c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87739",
    "data-name": "Path 87739",
    d: "M19.388,44.39l1.879-1.409a.494.494,0,0,1,.611,0l1.832,1.6a.507.507,0,0,1,.141.329.533.533,0,0,1-.141.376l-1.832,1.785a.454.454,0,0,1-.657,0l-1.879-1.926a.533.533,0,0,1-.141-.376A.381.381,0,0,1,19.388,44.39Z",
    transform: "translate(-6.479 -22.474)",
    fill: "#85899c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87740",
    "data-name": "Path 87740",
    d: "M20.236,35.964,18.4,49.583a.5.5,0,0,1-.47.423H9.293a.5.5,0,0,1-.47-.423L6.992,35.964a.466.466,0,0,1,.423-.517.418.418,0,0,1,.517.376l1.785,13.2h7.8l1.785-13.2a.55.55,0,0,1,.517-.423A.538.538,0,0,1,20.236,35.964Z",
    transform: "translate(0 -18.51)",
    fill: "#85899c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDustbinCat12);
export default __webpack_public_path__ + "static/media/dustbin_cat_12.a4c2084278117941ed5ad4f73e7f2980.svg";
export { ForwardRef as ReactComponent };